import { request } from './request';

export const getUserInfo = async (params = {}) => {
    const data = await request.get('/v1/user/profile', params);

    return data;
};

export const setUserInfo = async (params = {}) => {
    const data = await request.put('/v1/user/profile', params);

    return data;
};

// 获取个人云存储空间配额与使用详情
export const userStorageStatus = async (params = {}) => {
    const data = await request.get('/v1/user/storage/status', params);

    return data;
};

// 查询各项每日/终身奖励的领取状态
export const userBenefitsStatus = async (params = {}) => {
    const data = await request.get('/v1/user/benefits/status', params);

    return data;
};

export const rewardMonthly = async (params = {}) => {
    const data = await request.post('/v1/billing/reward/monthly', params);

    return data;
};

//
export const billingLedgers = async (params = {}) => {
    const data = await request.get('/v1/billing/ledgers', params);

    return data;
};

export const billingBalance = async (params = {}) => {
    const data = await request.get('/v1/billing/balance', params);

    return data;
};
